import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  Select,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";

const MoveAccountsCategoryModal = ({
  open,
  onClose,
  currentCategoryId,
  accountIds,
}) => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [categories, setCategories] = useState([]);
  const [targetCategory, setTargetCategory] = useState("");
  const ToasterToggle = JSON.parse(localStorage.getItem("Toaster"));

  useEffect(() => {
    if (!open) return;

    axios
      .get(`${baseURL}category/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        const filtered = res.data.filter((c) => c._id !== currentCategoryId);
        setCategories(filtered);
      })
      .catch(() => toast.error("Failed to load categories"));
  }, [open, currentCategoryId]);

  const handleSubmit = async () => {
    if (!targetCategory) {
      toast.error("Please select a target category");
      return;
    }

    try {
      const response = await axios.post(
        `${baseURL}category/move-profiles`,
        {
          fromCategoryId: currentCategoryId,
          category_id: targetCategory,
          profile_ids: accountIds,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (ToasterToggle) {
        toast.success(
          response.data.message || "Accounts move request initialized",
        );
      }

      onClose(true);
    } catch (err) {
      toast.error(err?.data?.message || err?.message || "Failed to move accounts");
    }
  };

  console.log(categories);
  return (
    <Dialog open={open} onClose={() => onClose(false)} fullWidth>
      <DialogTitle>Move Accounts to Another Category</DialogTitle>

      <DialogContent>
        <Select
          fullWidth
          value={targetCategory}
          onChange={(e) => setTargetCategory(e.target.value)}
          displayEmpty
        >
          <MenuItem value="" disabled>
            Select target category
          </MenuItem>
          {categories.map((cat) => (
            <MenuItem key={cat._id} value={cat._id}>
              {cat.categoryName}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => onClose(false)}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Move
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveAccountsCategoryModal;
